import {
	getVariableGroup,
	groupVariables,
} from '@dealstack/frontend/shared/components/EmailTemplates/utils/variableGroups';

export const defaultConditionVariable = (variables: string[]): string =>
	variables.find((name) => name === 'first_name') ??
	variables.find((name) => getVariableGroup(name) === 'recipient') ??
	variables.find((name) => getVariableGroup(name) !== 'links') ??
	variables[0] ??
	'';

export const conditionChoices = (variables: string[], current: string): string[] => {
	const ordered = groupVariables(variables).flatMap((entry) => entry.variables);
	return ordered.includes(current) || current === '' ? ordered : [current, ...ordered];
};
